// 友情链接数据。新增链接 = 在此数组追加一条 { id, url, nameKey, descKey }，
// 并在 src/i18n.js 的 zh/en 字典中添加对应的 links.* 文案键。
export const friendLinks = [
  {
    id: 'convert-lua',
    url: 'https://convertlua.top',
    nameKey: 'links.convertLua.name',
    descKey: 'links.convertLua.desc',
  },
  {
    id: 'game-font-factory',
    url: 'https://gamefont.top',
    nameKey: 'links.gameFontFactory.name',
    descKey: 'links.gameFontFactory.desc',
  },
  {
    id: 'steam-launch-toolkit',
    url: 'https://steamlaunch.top',
    nameKey: 'links.steamLaunch.name',
    descKey: 'links.steamLaunch.desc',
  },
];
